import React from "react";
import { useState } from "react";
import { Box, Button, Divider, Paper, Stack, Typography } from "@mui/material";
import { PersonAddAlt1Outlined, SearchOutlined } from "@mui/icons-material";
import BoxInput from "./BoxInput";
import { tokens, radius } from "../theme/theme";

/**
 * Filter bar above the clients table. Behaviour is unchanged — the same
 * `queryClients(false, null, rooms, region, costFrom, costTo)` call goes out
 * on "Знайти"; only the layout and styling were rebuilt so it matches the rest
 * of the panel and wraps instead of scrolling sideways.
 */
const ClientsHeader = ({ onAddItem, queryClients, regionSearchTerms, admin }) => {
  const [rooms, setRooms] = useState("");
  const [regions, setRegions] = useState("");
  const [costFrom, setCostFrom] = useState("");
  const [costTo, setCostTo] = useState("");

  return (
    <Paper
      elevation={0}
      sx={{
        mx: { xs: 1, md: 2 },
        mt: { xs: 1, md: 2 },
        // 12px, matching the gap under the view toggle below it.
        mb: 1.5,
        p: { xs: 1.5, md: 2 },
        borderRadius: radius.lg,
        border: "1px solid " + tokens.line,
      }}
    >
      <Stack direction="row" spacing={1.5} alignItems="center" flexWrap="wrap" useFlexGap>
        {admin && (
          <React.Fragment>
            <Button
              variant="contained"
              startIcon={<PersonAddAlt1Outlined />}
              onClick={onAddItem}
            >
              Додати клієнта
            </Button>
            <Divider
              orientation="vertical"
              flexItem
              sx={{ display: { xs: "none", lg: "block" } }}
            />
          </React.Fragment>
        )}

        <BoxInput
          label="Кімнат"
          inputWidth="100px"
          type="text"
          items={["1", "2", "3", "4"]}
          onChange={(newValue) => setRooms(newValue)}
        />
        <BoxInput
          label="Район"
          inputWidth="170px"
          type="text"
          items={regionSearchTerms}
          onChange={(newValue) => setRegions(newValue)}
        />

        <Stack direction="row" spacing={1} alignItems="center">
          <Typography variant="caption" sx={{ whiteSpace: "nowrap" }}>
            Бюджет
          </Typography>
          <BoxInput
            label="від"
            inputWidth="105px"
            type="number"
            items={["6000"]}
            onChange={(newValue) => setCostFrom(newValue)}
          />
          <BoxInput
            label="до"
            inputWidth="105px"
            type="number"
            items={["12000"]}
            onChange={(newValue) => setCostTo(newValue)}
          />
        </Stack>

        <Box sx={{ ml: { lg: "auto" } }}>
          <Button
            variant="outlined"
            startIcon={<SearchOutlined />}
            onClick={() =>
              queryClients(false, null, rooms, regions, costFrom, costTo)
            }
          >
            Знайти
          </Button>
        </Box>
      </Stack>
    </Paper>
  );
};

export default ClientsHeader;
